// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._-9KPYj-8x5ibTu {\n  background-color: #FFFFFF;\n  border: 1px solid #8777d9;\n  border-radius: 0.3rem;\n  color: #172B4D;\n  display: inline-block;\n  font-size: 1.2rem !important;\n  margin-top: 1rem;\n  padding: 0.75rem 1rem;\n  text-decoration: none;\n}\n._-9KPYj-8x5ibTu:hover {\n  background-color: #eae6ff;\n  color: #172B4D;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonLink": "_-9KPYj-8x5ibTu"
};
export default ___CSS_LOADER_EXPORT___;
